// extracted by mini-css-extract-plugin
export default {"modalOverlay":"FC-z","modalContent":"GC-z","header":"HC-z","close":"IC-z"};